import {Translation} from '@/i18n/locales/type.ts';

const zhHant: Translation = {
  home: {
    firstVisit: '	我是第一次來，沒有預約',
    returningVisitor: '請輸入您的電話號碼或電子郵件。',
    error_message: {
      invalid_token: '網絡連接不穩定。',
      search: '搜索過程中發生錯誤。',
      checkin: '辦理入住過程中發生錯誤。如果問題持續存在，請聯繫前台。',
    },
    dialog_message: {
      reservation: {
        checked_in: '您的預約已確認。辦理入住已完成。',
        no_customer: '未找到客戶資訊。\n請再次檢查電話號碼或電子郵件。',
      },
      walkin: {
        checked_in: '辦理入住已完成。請稍等片刻，我們將按順序為您服務。',
        no_customer_title: '找不到您的資訊。',
        no_customer_description: '這是您第一次來訪嗎？',
        start_first_visit: '開始首次登記',
        no_booking_title: '{{name}}，我們可以為您辦理當日登記。',
        no_booking_description:
          '我們可以為您辦理當日登記。\n根據現場狀況，可能需要等候，部分療程也可能受到限制。',
        start_checkin: '辦理登記',
      },
      no_booking: {
        title: '未找到預約資訊',
        description:
          '為了提供細心的診療和充分的諮詢時間，我們採用預約制運營。\n如果您已經預約，請向前台諮詢。',
      },
      invalid_building: {
        title:
          '醫院資訊不正確。如果您要辦理登記的醫院不是「首爾江南繆斯診所主樓2樓」，請向前台詢問正確的登記網站地址。',
      },
      common: {
        confirm: '確認',
        cancel: '取消',
      },
      confirm: {
        title: '{{name}}，您好！',
        description: '現在要辦理報到嗎？',
        confirm: '好的，請幫我報到',
        cancel: '不用了',
      },
    },
    form: {
      title: {
        name: '預約姓名',
        phone: '電話號碼',
        email: '電子郵件',
      },
      placeholder: {
        name: '請輸入您的姓名',
        phone: '請輸入您的電話號碼',
        email: '請輸入您的電子郵件',
      },
      description: '請至少輸入電話號碼或電子郵件中的一項。',
      button: {
        title: '辦理登記',
        loading: '搜索中...',
      },
      birth: {
        title: '請輸入出生日期以驗證您的資訊。',
        year: '年',
        month: '月',
        day: '日',
      },
    },
    customer_info: {
      title: '客戶資訊',
      name: '姓名',
      phone: '電話號碼',
      email: '電子郵件',
      button_title: '繼續辦理入住',
    },
    language_select: {
      button_title: '🌐 更改語言 / Language',
    },
  },
  common: {
    or: '或',
  },
  createChart: {
    title: '新建檔案登記',
    error_message: {
      invalid_form: '請輸入所有資訊。',
      checkin: '辦理入住過程中發生錯誤。',
    },
    dialog_message: {
      complete: {
        title:
          '檔案創建及入住已完成。\n當天訪問的客戶可能需要等待。感謝您的耐心等待。',
        button_title: '確認',
      },
    },
    form: {
      name: {
        title: '預約姓名',
        placeholder: '請輸入您的姓名。',
        passport_notice:
          '為了確保準確的預約與順暢的服務，請非韓國國籍的顧客輸入護照上的英文姓名。',
      },
      phone: {
        title: '電話號碼',
        placeholder: '請輸入您的電話號碼。',
      },
      email: {
        title: '電子郵件',
        placeholder: '請輸入您的電子郵件。',
      },
      birth: {
        title: '出生日期',
        year: '年',
        month: '月',
        day: '日',
      },
      gender: {
        title: '性別',
        male: '男',
        female: '女',
      },
      button: {
        title: '創建檔案並入住',
        loading: '正在創建檔案...',
      },
    },
  },
};

export default zhHant;
